import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Button, Paper, Typography, Slider as MuiSlider } from "@mui/material";
import { styled } from "@mui/material/styles";
import Slider from "react-slick";

import styles from "./SubscriptionBudgetAllocationCheck.module.scss";

type AllocationFact = {
  id: number;
  img: string;
  title: string;
};

type SubscriptionBudgetAllocationCheckProps = {
  btnText?: string;
  btnUrl?: string;
  progress?: number | string;
  showBtn?: boolean;
  showProgress?: boolean;
};

const data: AllocationFact[] = [
  {
    id: 1,
    title: "Consumers see over 5,000 ads daily — relevance wins attention.",
    img: "/img/budget_allocation/1.png",
  },
  {
    id: 2,
    title: "Ads with localized content see up to 4X higher engagement.",
    img: "/img/budget_allocation/1.png",
  },
  {
    id: 3,
    title: "The average ROI on digital ad spend is $2.80 for every $1.",
    img: "/img/budget_allocation/1.png",
  },
  {
    id: 4,
    title: "Emotional ads outperform rational ones by 31% in ROI.",
    img: "/img/budget_allocation/1.png",
  },
  {
    id: 5,
    title:
      "Facebook and Instagram drive over 50% of total franchise ad clicks.",
    img: "/img/budget_allocation/1.png",
  },
  {
    id: 6,
    title:
      "72% of consumers who search for local businesses visit within 5 miles.",
    img: "/img/budget_allocation/2.png",
  },
  {
    id: 7,
    title: "Localized ads can increase foot traffic by up to 80%.",
    img: "/img/budget_allocation/2.png",
  },
  {
    id: 8,
    title:
      "Zip Code Targeting ads are 2X more effective than non-targeted ones.",
    img: "/img/budget_allocation/2.png",
  },
  {
    id: 9,
    title:
      "78% of location-based mobile searches result in an offline purchase.",
    img: "/img/budget_allocation/2.png",
  },
  {
    id: 10,
    title:
      "Franchisees who market locally grow 20% faster than those who don’t.",
    img: "/img/budget_allocation/2.png",
  },
  {
    id: 11,
    title: "The average consumer uses 3–4 devices before making a purchase.",
    img: "/img/budget_allocation/3.png",
  },
  {
    id: 12,
    title: "90% of consumers trust peer reviews more than brand ads.",
    img: "/img/budget_allocation/3.png",
  },
  {
    id: 13,
    title: "70% of smartphone users act on an ad seen within an hour.",
    img: "/img/budget_allocation/3.png",
  },
  {
    id: 14,
    title: "47% of shoppers say a personalized experience drives loyalty",
    img: "/img/budget_allocation/3.png",
  },
  {
    id: 15,
    title: "Millennials prefer short, punchy ads — 6 seconds is ideal.",
    img: "/img/budget_allocation/3.png",
  },
  {
    id: 16,
    title: "Franchisees spend 25% more when they feel supported by HQ.",
    img: "/img/budget_allocation/4.png",
  },
  {
    id: 17,
    title: "Top-performing franchisees run 30% more campaigns annually.",
    img: "/img/budget_allocation/4.png",
  },
  {
    id: 18,
    title:
      "Brands with flexible local options see 40% higher marketing adoption.",
    img: "/img/budget_allocation/4.png",
  },
  {
    id: 19,
    title: "75% of franchise brands now use co-op funds for digital.",
    img: "/img/budget_allocation/4.png",
  },
  {
    id: 20,
    title: "Empowered franchisees improve brand consistency by 3X.",
    img: "/img/budget_allocation/4.png",
  },
  {
    id: 21,
    title: "Combining search and social ads increases conversion rates by 22%.",
    img: "/img/budget_allocation/5.png",
  },
  {
    id: 22,
    title: "Multi-channel campaigns are 37% more effective than single-channel",
    img: "/img/budget_allocation/5.png",
  },
  {
    id: 23,
    title: "Ad spend optimized by location performs 2–3X better.",
    img: "/img/budget_allocation/5.png",
  },
  {
    id: 24,
    title: "A/B testing creatives can boost CTRs by up to 150%",
    img: "/img/budget_allocation/5.png",
  },
  {
    id: 25,
    title: "Campaigns with clear CTAs see 285% more interaction.",
    img: "/img/budget_allocation/5.png",
  },
  {
    id: 26,
    title: "Humans process visuals 60,000X faster than text — make it visual.",
    img: "/img/budget_allocation/6.png",
  },
  {
    id: 27,
    title: "Curiosity-driven headlines increase ad recall by 40%.",
    img: "/img/budget_allocation/6.png",
  },
  {
    id: 28,
    title: "Repetition boosts ad retention — 3 impressions are better than 1.",
    img: "/img/budget_allocation/6.png",
  },
  {
    id: 29,
    title: "Motion content holds attention 5X longer than static ads.",
    img: "/img/budget_allocation/6.png",
  },
  {
    id: 30,
    title:
      "A pause during loading is the perfect time to educate and build trust.",
    img: "/img/budget_allocation/6.png",
  },
];

const makeRandom = <T,>(arr?: T[]) => {
  if (!arr) return [];
  const r: T[] = [];
  const getREl = () => {
    const rIdx = Math.floor(Math.random() * arr.length);
    if (r.includes(arr[rIdx])) {
      getREl();
    } else {
      return r.push(arr[rIdx]);
    }
  };

  for (let i = 0; i < arr.length; i++) {
    getREl();
  }

  return r;
};

// Replace withStyles → styled
const ProgressSlider = styled(MuiSlider)(() => ({
  height: 10,
  "& .MuiSlider-track": {
    height: 10,
    borderRadius: "var(--radius-round)",
  },
  "& .MuiSlider-rail": {
    backgroundColor: "var(--neutral-500)",
    opacity: 1,
    height: 10,
  },
  "& .MuiSlider-thumb": {
    height: 0,
    width: 0,
    boxShadow: "none",
    "&:hover, &:focus": {
      boxShadow: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    top: -22,
    background: "transparent",
    color: "var(--neutral-700)",
    fontWeight: "bold",
  },
}));

function SubscriptionBudgetAllocationCheck({
  progress,
  showProgress = true,
  showBtn = false,
  btnUrl = "/dashboard",
  btnText = "Back to Dashboard",
}: SubscriptionBudgetAllocationCheckProps) {
  const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    lazyLoad: true,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    arrows: false,
  };

  const randomData = useMemo(() => makeRandom(data), []);

  return (
    <div className={`${styles.loader} text-center overflow-none`}>
      <Paper className={`${styles.imageContainer} mx-auto py-4 px-2`}>
        <Typography component="h2" variant="h6" className="text-center">
          Getting the platform ready for you
        </Typography>

        <Slider {...settings}>
          {randomData.map((d) => (
            <div className="text-center" key={d.title}>
              <img
                src={d.img}
                className="img-fluid mx-auto my-2"
                style={{ width: 300, objectFit: "contain" }}
                alt="info"
              />
              <Typography variant="body2" className="fw-sb">
                {d.title}
              </Typography>
            </div>
          ))}
        </Slider>
      </Paper>

      {showProgress ? (
        <div style={{ maxWidth: "calc(100vw - 50px)", width: "70%" }}>
          <ProgressSlider
            value={progress ? Number(progress) : 0}
            valueLabelFormat={(v) => `${v}%`}
            aria-labelledby="progress-slider"
            min={0}
            max={100}
            valueLabelDisplay="on"
            className="my-5"
          />
        </div>
      ) : null}

      {showBtn ? (
        <div className="text-center my-3">
          <Button
            className="mx-auto"
            variant="contained"
            color="primary"
            component={Link}
            to={btnUrl}
            size="large"
          >
            {btnText}
          </Button>
        </div>
      ) : null}
    </div>
  );
}

export default SubscriptionBudgetAllocationCheck;
